import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core'
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators, NgModel } from '@angular/forms';
import { Api, Session, States } from '../services/index';
import { Patient } from '../models/index';
import { Payment,PaymentMethod,PaymentMethodResult,Month,Months } from '../models/sf-payments'
import {TranslateService} from '@ngx-translate/core'; 

@Component({
	selector: 'dashboard-add-payment',
	templateUrl: './dashboard-add-payment.html',
	styleUrls: ['./dashboard-add-payment.css']
})

export class DashboardPaymentsAdd implements OnInit{
	@Input() set cardDetail(cardDetail:PaymentMethodResult){
		if(cardDetail){
			if(cardDetail.hasOwnProperty('cardid')){
				this.formPayments.controls['ccFirstName'].setValue(cardDetail.cardholderfirstname);
				this.formPayments.controls['ccLastName'].setValue(cardDetail.cardholderlastname);
				this.formPayments.controls['ccZipCode'].setValue(cardDetail.billingzip);
				this.formPayments.controls['ccNumber'].setValue('XXXXXXXXXXXX'+cardDetail.cardnumber);
				this.formPayments.controls['ccExpirationMonth'].setValue(cardDetail.cardexpirationmonth);
				this.formPayments.controls['ccExpirationYear'].setValue(cardDetail.cardexpirationyear);
				this.formPayments.controls['ccv2Code'].setValue(cardDetail.ccv);
				this.isEditPaymet = true;
				this.paymentToEdit = cardDetail;
			}else{
				this.formPayments.controls['ccFirstName'].setValue(this.patient.profile.firstName);
				this.formPayments.controls['ccLastName'].setValue(this.patient.profile.lastName);
				this.formPayments.controls['ccZipCode'].setValue(this.patient.profile.zipCode);
				this.formPayments.controls['ccNumber'].setValue('');
				this.formPayments.controls['ccExpirationMonth'].setValue('');
				this.formPayments.controls['ccExpirationYear'].setValue('');
				this.formPayments.controls['ccv2Code'].setValue('');
				this.isEditPaymet = false;
			}
		}
	};
	@Input() isForPayNow: string;
	
	@Output() 
	saveEvent = new EventEmitter<PaymentMethodResult>();
	@Output()
	cancelEvent = new EventEmitter<String>();



    public expMonths: Object[];
	public yearData: YearData[];
	public localFields: Object = { text: 'Month', value: 'Id' };
	public yearFields: Object = { text: 'Year', value: 'Id' };
	public autoreactiveplaceholder: String;
	public autoreactiveYearplaceholder: String;

	patient: Patient;
	formPayments: FormGroup;
	months: Array<Month>;
	expirationYears: Array<String>;
	paymentMethods:Array<PaymentMethodResult>;
	paymentToEdit:PaymentMethodResult;
	isEditPaymet:boolean;
	isPrefered:boolean;
	isMonthDataLoaded:boolean = false;
	isYearDataLoaded:boolean = false;

	loading:boolean = false;

	constructor(private fb:FormBuilder,
		private session: Session,
		private translateService: TranslateService,
		private api: Api){
		this.paymentMethods = new Array<PaymentMethodResult>();
		this.isEditPaymet = false;
		this.formPayments = this.fb.group({
			ccFirstName: [null, <any>Validators.required],
			ccLastName: [null, <any>Validators.required],
			ccNumber: [null, Validators.compose([Validators.required, Validators.pattern('[0-9-]{13,16}')])],
			ccExpirationMonth: [null, Validators.compose([Validators.required, Validators.pattern('[0-9-]{1,2}')])],
			ccExpirationYear:  [null, Validators.compose([Validators.required, Validators.pattern('[0-9-]{4,4}')])],
			ccv2Code: [null, Validators.compose([Validators.required, Validators.pattern('[0-9-]{3,4}')])],
			ccZipCode: [null, Validators.compose([Validators.required, Validators.pattern('[0-9-]{5,5}')])]
		});
	}

	buildExpirationYears() {
		this.yearData = Array<YearData>()
		let currentYear = new Date().getFullYear();
		let yearsInFuture = 20;
		let years = new Array<string>();
		years.push(currentYear.toString());
	
		for (let i = 1; i < yearsInFuture; i++) {
		  var year = currentYear + i;
		  years.push(year.toString());
		  let _years = new YearData();
		  _years.Id = year.toString();;
		  _years.Year = year.toString();
		  this.yearData.push(_years);
		}
		this.isYearDataLoaded = true;
		return years; 
	}

	ngOnInit(){
		console.dir(this.session);
		this.getPatient(this.session.patientId);
		this.months = Months.asArray;
		this.expirationYears = this.buildExpirationYears();

		this.translateService.get('EXAM_PAYMENT.EXPIRATION_MONTH').subscribe((res: string) => {
			if(res){
			  this.autoreactiveplaceholder  = res;
			}else{
			  this.autoreactiveplaceholder  = 'Expiration Month';
			}
			
			console.log(res);
		  });  
		  this.translateService.get('EXAM_PAYMENT.EXPIRATION_YEAR').subscribe((res: string) => {
			if(res){
			  this.autoreactiveYearplaceholder  = res;
			}else{
			  this.autoreactiveYearplaceholder  = 'Expiration Year';
			}
			
			console.log(res);
		  });  
		this.expMonths = [
			{ Id: '01', Month: this.translateText('MONTHS', '01') },
			{ Id: '02', Month: this.translateText('MONTHS', '02') },
			{ Id: '03', Month: this.translateText('MONTHS', '03') },
			{ Id: '04', Month: this.translateText('MONTHS', '04') },
			{ Id: '05', Month: this.translateText('MONTHS', '05') },
			{ Id: '06', Month: this.translateText('MONTHS', '06')},
			{ Id: '07', Month: this.translateText('MONTHS', '07') },
			{ Id: '08', Month: this.translateText('MONTHS', '08') },
			{ Id: '09', Month: this.translateText('MONTHS', '09') },
			{ Id: '10', Month: this.translateText('MONTHS', '10') },
			{ Id: '11', Month: this.translateText('MONTHS', '11') },
			{ Id: '12', Month: this.translateText('MONTHS', '12') }
		];
		this.isMonthDataLoaded = true;
	}
	translateText(text, month): string{
		let monthVar = text + '.' + month
		let results = '';
		this.translateService.get(monthVar).subscribe((res: string) => {
			if(res){
				results =  res;
			}else{
				results = 'Month';
			}
			
			console.log(res);
		  });
		  return results;
	}
	getPatient(patientId) {
		let patient = this.api.getPatientById(patientId);
		patient.subscribe(response => {
			this.patient = response;
			this.formPayments.controls['ccFirstName'].setValue(response.profile.firstName);
			this.formPayments.controls['ccLastName'].setValue(response.profile.lastName);
			this.formPayments.controls['ccZipCode'].setValue(response.profile.zipCode);
		})
	}

	cancelModal(){
		this.cancelEvent.next('CancelCard');
	}
	
	savePayment(){
		this.loading = true;
		let data = new PaymentMethod();
		data.contactfirstname = this.patient.profile.firstName;
		data.cardholderfirstname = this.formPayments.value.ccFirstName;

		data.contactlastname = this.patient.profile.lastName;
		data.cardholderlastname = this.formPayments.value.ccLastName;

		data.contactemail = this.patient.email;
		data.contactphone = this.patient.phoneNumber;

		data.cardnumber = this.formPayments.value.ccNumber;
		data.cardexpirationmonth = this.formPayments.value.ccExpirationMonth;
		data.cardexpirationyear = this.formPayments.value.ccExpirationYear;
		data.billingzip = this.formPayments.value.ccZipCode;
		data.ccv = this.formPayments.value.ccv2Code;
		data.active = true;
		if(this.isForPayNow === 'true'){
			data.ispreffered = true;
		}else{
			data.ispreffered = false;
		}
		
		
		
		if(this.isEditPaymet){
			let delData = new PaymentMethod();
			delData.active = false;
			delData.ispreffered = false;

			this.api.updateUserPaymentMethods(this.paymentToEdit.cardid, delData).subscribe(result=>{
				this.api.saveUserPaymentMethod(this.session.patientId, data).subscribe(result=>{
					this.loading = false;
					this.saveEvent.next(result);
				});
			});
		}else{
			this.api.saveUserPaymentMethod(this.session.patientId, data).subscribe(result=>{
				this.loading = false;
				this.saveEvent.next(result);
			});
		}
	}
}
export class YearData {
	Year: string;
	Id: string;
  }